
import { get as cookieGet } from 'js-cookie';
import JhBridge from 'jh-bridge';
const device = {}

let ua = navigator.userAgent

const android = !!ua.match(/(Android);?[\s/]+([\d.]+)?/)
const iPad = !!ua.match(/(iPad).*OS\s([\d_]+)/)
const iPhone = !iPad && !!ua.match(/(iPhone\sOS)\s([\d_]+)/)

device.ios = device.android = device.iPhone = device.iPad = device.androidChrome = false
device.os = 'h5'
device.terminal = 'h5'
if (android) {
  device.os = 'android'
  device.osVersion = android[2]
  device.android = true
  device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0
  if (cookieGet('selfUA')) {
    device.terminal = 'android'
  }
  if (JhBridge.isJhApp && JhBridge.isAndroid) {
    device.terminal = 'android';
  }
}

if (iPad || iPhone) {
  device.os = 'ios'
  device.ios = true
  if (cookieGet('selfUA')) {
    device.terminal = 'ios'
  }
  if (JhBridge.isJhApp && JhBridge.isIOS) {
    device.terminal = 'ios';
  }
}

if (ua.indexOf('miniProgram') >= 0) {
  device.terminal = 'wmp';
}

if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
  if (device.osVersion.split('.')[0] === '10') {
    device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0]
  }
}

device.webView = true
device.miniProgram = ua.indexOf('miniProgram') >= 0

if (ua.match(/MicroMessenger/i)) {
  device.thirdChannel = 'weixin'
} else if (ua.match(/AliApp/i)) {
  device.thirdChannel = 'alipay'
}

export default device
